module.exports = __webpack_public_path__ + "img/saccharose.0172df22.png";